import React, { useContext, useEffect, useState } from "react";

import { MaterialReactTable } from "material-react-table";
import { Plane } from "lucide-react";
import { base_url } from "../../config";
import axios from "axios";
import VisaModal from "./VisaModal";
import RegistrationContext from "../../contexts/RegistrationContext";

const UserTable = () => {
  const [data, setData] = useState([]);
  const [code, setCode] = useState("");
  const [type, setType] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
    const [rowData, setRowData] = useState(null);
  const {
    reloadAdminBadges,
    setReloadAdminBadges,
  } = useContext(RegistrationContext);

  useEffect(() => {
    axios
      .get(`${base_url}/api/admin/visa`)
      .then((response) => setData(response.data))
      .catch((error) => console.error("Error visa applications:", error));
  }, [reloadAdminBadges]);

  const columns = [
    {
      accessorKey: "code",
      header: "Code",
    },
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "email",
      header: "Email",
    },
    {
      accessorKey: "type",
      header: "Type",
    },
    {
      id: "actions",
      header: "Validate",
      Cell: ({ row }) => (
        <button
          onClick={() => handleAction(row.original)}
          style={{
            padding: "6px 12px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            background: "#f5f5f5",
            cursor: "pointer",
          }}
        >
          Open
        </button>
      ),
    },
  ];

  const handleAction = (row) => {

    setCode(row.code);
    setType(row.type);
    setRowData(row);
    setModalOpen(true);
  };

  const acceptVisa = () => {
    axios
      .post(`${base_url}/api/admin/visa/accept`, {
        code: code,
        type: type,
      })
      .then((response) => {
      
        // setData((prevData) =>
        //   prevData.filter((item) => item.code !== code)
        // );
        setReloadAdminBadges(reloadAdminBadges + 1);
      })
      .catch((error) => console.error("Error accepting visa:", error));
  }

  const rejectVisa = () => {
    setReloadAdminBadges(reloadAdminBadges + 1);
  }

  return (
    <>
      <div className="text-2xl mt-4 pb-4 font-bold flex gap-8 items-center">
        <Plane />
        Visa Validations
      </div>
  
      <div style={{ flex: "1 1 0", paddingBottom: "20px" }}>
        <MaterialReactTable columns={columns} data={data} />
      </div>
      <VisaModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        row={rowData}
        code={code}
        type={type}
        onAccept={() => acceptVisa()}
        onDecline={() => rejectVisa()}
      />
    </>
  );
};

export default UserTable;
